import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { updateSubAccount } from '../../../../../api'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../../../../auth-context'
import moment from 'moment';
import Modal from '../../../../../components/modal'
import DeleteIcon from '@material-ui/icons/DeleteForever';
import { DashboardContext } from '../../../dashboard-context'
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { Row, Action } from '../../../../../components/action-button'
import PersonIcon from '@material-ui/icons/Person';
import ChatIcon from '@material-ui/icons/Chat';
import config from "../../../../../config"


const WhiteCheckbox = withStyles({
  root: {
    color: "#070c29",
    "&$checked": {
      color: "#070c29",
    },
  },
  checked: {},
})((props) => <Checkbox {...props} />);

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`;

const TableTitle = styled.h2`
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`;

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`;

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`;

const TableHead = styled.thead`
  color: #FFF;

`;

const TableBody = styled.tbody`
`;

const TableHeadRow = styled.tr`
`;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: .9rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  text-align: left;
  top: 0;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-size: .9rem;
  padding: 4px 8px;
  text-align: left;
`;

const RemoveText = styled.h4`
  color: #555;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
`;

const AccountsTable = (props) => {
  const { teamSearch, openSnackbar, setClientsTrainerID, setShowMessages, setChannelFilter } = useContext(DashboardContext);
  const { user, updateUser } = useContext(AuthContext);
  const [showModal, updateShowModal] = useState(false)
  const [deletionID, updatedeletionID] = useState('')
  const [deletionEmail, updatedeletionEmail] = useState('')
  const [loading, updateLoading] = useState(false)

  const handleCheckbox = (update_id, val) => {
    updateLoading(true)

    updateSubAccount(user.id, update_id, {role_id: val}).then((res) => {
      let newUser = Object.assign({}, user)
      let updateIndex = newUser.team.findIndex(account => account.id === update_id);
      newUser.team[updateIndex].role = (val === 2 ? 'Admin' : 'Trainer')

      setTimeout(() => {
        updateLoading(false)
        updateShowModal(false)
        updateUser(newUser)
        openSnackbar('Account permission updated', false)
      }, 700);
    }).catch((err) => {
      updateLoading(false)
      openSnackbar('Error updating account', true)
    })
  }

  const viewMessages = async (trainer_id, trainerName) => {
    setChannelFilter({
      trainerName: trainerName,
      filter: {
        type: "portal",
        portal_owner: `${config.STREAMCHAT.portalUserPrefix}${user.owner_id}`,
        members: { $in: [`${config.STREAMCHAT.portalUserPrefix}${trainer_id}`] },
      },
    })
    setShowMessages(true);
  }

  const handleDelete = (cancel_id) => {
    updateLoading(true)

    updateSubAccount(user.id, cancel_id, {active: 0}).then((res) => {
      let newUser = Object.assign({}, user)
      _.remove(newUser.team, (member) => {
        return member.id === cancel_id
      })

      setTimeout(() => {
        updateLoading(false)
        updateShowModal(false)
        updateUser(newUser)
        openSnackbar('Account successfully removed', false)
      }, 700);
    }).catch((err) => {
      updateLoading(false)
      openSnackbar('Error deleting account', true)
    })
  }

  let accounts =_.cloneDeep(user.team);
  if (teamSearch.searchTerm !== '') {
    if (teamSearch.searchType === 'Email')
      accounts = accounts.filter(client => client.email_address.toLowerCase().includes(teamSearch.searchTerm.toLowerCase()))
    else if (teamSearch.searchType === 'Name')
      accounts = accounts.filter(client => client.name.toLowerCase().includes(teamSearch.searchTerm.toLowerCase()))
  }

  return (
    <Container>
      <TableTitle>Found {accounts.length} account(s)</TableTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell bigWidth>Email Address</HeadCell>
              <HeadCell bigWidth>Full Name</HeadCell>
              <HeadCell>Admin Permission</HeadCell>
              <HeadCell>Clients</HeadCell>
              <HeadCell bigWidth>Created Date</HeadCell>
              <HeadCell style={{textAlign: 'center', width: '180px'}}>Actions</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
          {accounts.map((entry, index) => {
            return (
              <TableBodyRow key={entry.id}>
                <DataCell>{entry.email_address}</DataCell>
                <DataCell>{entry.name}</DataCell>
                <DataCell>
                  {entry.role === 'Owner' ?
                    'Owner'
                  :
                    <WhiteCheckbox
                      checked={(entry.role === 'Owner' || entry.role === 'Admin') ? true: false}
                      onChange={() => handleCheckbox(entry.id, entry.role === 'Admin' ? 3 : 2)}
                      inputProps={{ "aria-label": "checkbox" }}
                    />
                  }
                </DataCell>
                <DataCell number>
                  {entry.client_count}
                </DataCell>
                <DataCell number>{moment.utc(entry.created_at).format('MMM D, YYYY')}</DataCell>
                <DataCell style={{width: '180px'}}>
                  <Row style={{justifyContent: 'center'}}>
                    <Action
                      icon={<PersonIcon />}
                      text="View clients"
                      onClick={() => {
                        props.history.push("/dashboard/overview");
                        setClientsTrainerID(entry.id);
                      }}
                    />
                    {user.role_id === 1 &&
                      <Action
                        icon={<ChatIcon />}
                        text="View messages"
                        onClick={() => viewMessages(entry.id, entry.name)}
                      />
                    }
                    {entry.role === 'Owner' ?
                      <Action
                        icon={<DeleteIcon />}
                        iconColor='#da0f0f'
                        text="Delete"
                        onClick={() => {}}
                        style={{ cursor: 'default', opacity: 0}}
                      />
                    :
                      <Action
                        icon={<DeleteIcon />}
                        iconColor='#da0f0f'
                        text="Delete"
                        onClick={() => {
                          updateShowModal(true);
                          updatedeletionID(entry.id);
                          updatedeletionEmail(entry.email_address);
                        }}
                      />
                    }
                  </Row>
                </DataCell>
                {/* <ButtonCell>
                  <ClientButton onClick={() => { props.history.push("/dashboard/overview"); setClientsTrainerID(entry.id); }}>View Clients</ClientButton>
                  {entry.role !== 'Owner' && <IconButton color="secondary" onClick={() => { updateShowModal(true); updatedeletionID(entry.id); updatedeletionEmail(entry.email_address) }}><DeleteIcon/></IconButton>}
                </ButtonCell> */}
              </TableBodyRow>
            )
          })}
          </TableBody>
        </Table>
        <Modal
          title={`Remove User`}
          message={`Removing this user will immediately deactivate their account. They will no longer be able to login and manage clients.`}
          submitLabel="Remove"
          open={showModal}
          onClose={() => updateShowModal(false)}
          handleSubmit={() => handleDelete(deletionID)}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <RemoveText>
            {deletionEmail}
          </RemoveText>
        </Modal>
      </TableContainer>
    </Container>
  )
}

export default withRouter(AccountsTable)